import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tbody", {
        "data-slot": "table-body",
        class: _normalizeClass($setup.cn('[&_tr:last-child]:border-0', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
